<template>
  <div :class="[wrapClass, 'yfd-upload-wrap']">
    <div v-if="parseStatus === 'error'" class="upload-error">
      <img src="../../../public/img/resume.png" alt="" />
      <p class="upload-warring">{{ errorMessage }}</p>
      <a-upload :accept="acceptFileType" :beforeUpload="beforeUpload">
        <a-button type="link" class="extra-button">
          重新上传
        </a-button>
      </a-upload>
    </div>
    <div v-else-if="parseStatus === 'parsing'" class="upload-parsing">
      <img src="../../../public/img/resume.png" alt="" />
      <p class="upload-warring">简历解析中</p>
      <a-button type="link" class="extra-button" @click="cancelParse"
        >取消</a-button
      >
    </div>
    <div v-else-if="parseStatus === 'success'" class="upload-success">
      <img src="../../../public/img/resume.png" alt="" />
      <p class="upload-warring">{{ fileName }}</p>
      <div class="success-button-wrap">
        <a-upload
          :accept="acceptFileType"
          :beforeUpload="beforeUpload"
          class="success-update-button-wrap"
        >
          <a-button type="link" class="success-update-button"
            >更新简历</a-button
          >
        </a-upload>
        <div class="divider" />
        <a-button
          type="link"
          class="success-delete-button"
          @click="removeResume"
          >删除简历</a-button
        >
      </div>
    </div>
    <div v-else>
      <a-upload
        :accept="acceptFileType"
        :beforeUpload="beforeUpload"
        class="yfd-upload"
      >
        <a-button class="yfd-upload-button" ref="uploadButton">
          上传简历
        </a-button>
      </a-upload>
      <p class="extra">
        将文件大小控制在5M以内，支持PDF、DOC、
        DOCX、PNG、JPG、JPEG文件格式的上传。
      </p>
    </div>
  </div>
</template>
<script>
const acceptFileType =
  '.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/png,image/jpeg'
import { yfdApiHost } from '@/service/request'
import axios from 'axios'
let parseCancel = null
export default {
  props: {
    accept: Array,
  },
  data() {
    return {
      acceptFileType,
      file: null,
      errorMessage: '解析错误',
      parseStatus: 'waiting',
    }
  },
  computed: {
    wrapClass() {
      // 区分不同产品线主题色
      return `upload-${this.$route.params.department}`
    },
    fileName() {
      return this.file ? this.file.name : '测试'
    },
  },
  methods: {
    beforeUpload(file) {
      this.parseSuccess = false
      if (file.size / 1024 / 1024 > 5) {
        this.parseError('简历大小超过5M，请重新上传')
      } else {
        this.errorMessage = ''
        this.parseStatus = 'parsing'
        this.file = file
        this.$emit('change', file)
        this.parseResume()
      }
      return false
    },
    async parseResume() {
      let formData = new FormData()
      formData.append('file', this.file)
      try {
        let res = await axios.post(
          `${
            window.location.protocol
          }//${yfdApiHost}/ep-garden-candidate/api/resume/parse`,
          formData,
          {
            cancelToken: new axios.CancelToken(function executor(c) {
              parseCancel = c
            }),
          },
        )
        if (res.code === 1) {
          this.$emit('parseSuccess', res.data)
          this.parseStatus = 'success'
        } else {
          this.parseError('简历解析失败')
        }
      } catch {
        this.parseError('简历解析失败')
      }
    },
    parseError(message) {
      this.parseStatus = 'error'
      this.errorMessage = message
    },
    handleReupload() {
      this.$refs.uploadButton.click()
    },
    removeResume() {
      this.file = null
      this.parseStatus = 'waiting'
    },
    cancelParse() {
      parseCancel && parseCancel('取消简历解析请求')
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@style/common.less';
.yfd-upload-wrap {
  & > div {
    background: rgba(246, 246, 246, 1);
    border: 2px solid rgba(235, 235, 235, 1);
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    height: 175px;
    img {
      width: 29px;
      margin: 36px 0 20px;
    }
    .upload-warring {
      font-size: 10px;
      font-weight: 600;
      color: #333;
      line-height: 14px;
      margin: 0 auto 14px;
      text-align: center;
      width: 80%;
    }
    .extra-button {
      margin-bottom: 38px;
      font-size: 12px;
      line-height: 16px;
    }
    .yfd-upload {
      display: inline-block;
      .yfd-upload-button {
        width: 130px;
        height: 39px;
        line-height: 37px;
        background: rgba(255, 255, 255, 1);
        border: 2px solid rgba(235, 235, 235, 1);
        margin: 30px 0 20px;
        font-size: 14px;
        color: @tutor-color;
      }
    }
    .extra {
      margin: 0 33px 40px;
      font-size: 13px;
      color: #666;
      line-height: 23px;
    }
  }
  .upload-error {
    .extra-button {
      color: @tutor-color;
    }
  }
  .upload-parsing {
    .extra-button {
      color: #999;
    }
  }
  .upload-success {
    .upload-warring {
      margin-bottom: 32px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .success-button-wrap {
      width: 100%;
      border-top: 2px solid rgba(235, 235, 235, 1);
      height: 41px;
      background-color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .success-update-button-wrap,
      .success-delete-button {
        width: 50%;
        line-height: 10px;
      }
      .success-update-button,
      .success-delete-button {
        font-size: 12px;
        color: #999;
      }
      .ant-upload,
      .success-update-button {
        width: 100%;
      }
      .divider {
        width: 1px;
        height: 50%;
        background-color: #ebebeb;
      }
    }
  }
  &.upload-zebra {
    & > div {
      .yfd-upload {
        .yfd-upload-button {
          color: @zebra-color;
        }
      }
    }
    .upload-error {
      .extra-button {
        color: @zebra-color;
      }
    }
  }
}
</style>
<style lang="less">
.yfd-upload-wrap {
  .upload-success {
    .success-button-wrap {
      .ant-upload {
        width: 100%;
      }
    }
  }
}
.ant-upload-list {
  display: none;
}
</style>
